import Hero from './components/Hero';
import OriginStory from './components/OriginStory';
import BrandDefinition from './components/BrandDefinition';
import WhoWeServe from './components/WhoWeServe';
import MoreThanClothing from './components/MoreThanClothing';
import TheComeback from './components/TheComeback';
import Contact from './components/Contact';
import LocalDelivery from './components/LocalDelivery';
import FAQ from './components/FAQ';
import NextDrop from './components/NextDrop';
import Community from './components/Community';
import FinalCTA from './components/FinalCTA';
import Footer from '../home/components/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Hero />
      <OriginStory />
      <BrandDefinition />
      <WhoWeServe />
      <MoreThanClothing />
      <TheComeback />
      <Contact />
      <LocalDelivery />
      <FAQ />
      <NextDrop />
      <Community />
      <FinalCTA />
      <Footer />
    </div>
  );
}